import { useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import * as S from './styles';
import * as Base from '../styles';
import TextInput from 'components/Widget/Input/TextInput';
import useOnClickOutside from 'hooks/useOnClickOutside';

interface ColorInputProps {
	color: string; // of form #FF0000
	onColorChange?: (color: string) => void;
	// Marks the displayed color as a placeholder (e.g. caller's underlying value
	// is unset/transparent). Visually fades the swatch and hex display so the
	// user knows the shown color isn't really applied. The popup is NOT faded
	// when opened — once the user engages, they can see the picker clearly.
	inactive?: boolean;
}

const ColorInput = ({ color, onColorChange, inactive }: ColorInputProps) => {
	const colorInput = useRef(null);

	const [isOpen, setOpen] = useState(false);
	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onChangeColor = (color: string) => {
		onColorChange?.(color);
	};

	const open = () => {
		setOpen(true);
	};

	const close = () => {
		setOpen(false);
	};

	useOnClickOutside(colorInput, close);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	return (
		<Base.Base>
			<S.ColorSection>
				<S.Swatch color={color} onClick={open} $inactive={inactive} />
				{isOpen && (
					<S.ColorInput ref={colorInput}>
						<HexColorPicker color={color} onChange={onChangeColor} />
						<TextInput value={color} onChange={(e) => onChangeColor(e.target.value)} />
					</S.ColorInput>
				)}
			</S.ColorSection>
			<S.HexText $inactive={inactive}>
				<TextInput value={color} onChange={(e) => onChangeColor(e.target.value)} />
			</S.HexText>
		</Base.Base>
	);
};

export default ColorInput;
